import styled from 'styled-components';
import { Body2, colors, spacing } from 'ui/theme';

export const DeliveryText = styled(Body2)`
  color: ${colors.textSecondary};
  margin-bottom: ${spacing.plusHalf};
`;

export const PopoverOL = styled.ol`
  padding-left: ${spacing.base};
`;

export const PopoverLI = styled.li`
  margin-bottom: ${spacing.base};
`;
